// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_NO_RELATED_ITEMS_FOUND = "Nena\u0161li jsme \u017e\u00e1dn\u00e9 podobn\u00e9 inzer\u00e1ty.";
export const HOME_SHOW_MORE_POSTS = "Zobraz dal\u0161\u00ed";
export const RELATED_BAZAAR_PRODUCTS = "Podobn\u00e9 inzer\u00e1ty";
